import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-rewrite-output-error',
  imports: [TranslateModule],
  templateUrl: './rewrite-output-error.component.html',
  styleUrl: './rewrite-output-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RewriteOutputErrorComponent {}
